const integracoesHome = () =>
  import(/* webpackChunkName: "group-pabx-integracoes" */ '../modules/_views/IntegracoesHome')
const Cadastrointegracoess = () =>
  import(/* webpackChunkName: "group-pabx-integracoes" */ '../modules/_views/CadastroIntegracoes')
const Atualizarintegracoes = () =>
  import(/* webpackChunkName: "group-pabx-integracoes" */ '../modules/_views/AtualizarIntegracoes')

import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'integracoes',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: integracoesHome,
    name: 'integracoes',
  },
  {
    path: 'integracoes/criar',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: Cadastrointegracoess,
    name: 'integracoes/criar',
  },
  {
    path: 'integracoes/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: Atualizarintegracoes,
    name: 'integracoes/atualizar',
    props: true,
  },
]
